// extracted by mini-css-extract-plugin
module.exports = {"body":"SidebarLayout_body__4bilN","content":"SidebarLayout_content__ARQZO","sidebar":"SidebarLayout_sidebar__2r8nE","page":"SidebarLayout_page__XAwWF"};